import styled from 'styled-components';

export default {
    Modal: styled.div.attrs({ className: 'modal' })`
        position: fixed;
        top: 0;
        left: 0;
        width: 100vw;
        height: 100%;
        background: rgba(66, 65, 65, 0.6);
        z-index: 101;
        overflow-y: auto;
        @media (min-width: 700px) {
            overflow-y: hidden;
        }
    `,
    ModalContent: styled.div.attrs({ className: 'modal-content' })`
        font-family: Toyota Display;
        position: relative;
        box-shadow: 0 2px 5px rgba(0,0,0,0.5);
        top: 406px;
        left: 50%;
        transform: translateX(-50%) translateY(-50%);
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        align-items: flex-start;
        height: auto;
        max-height: ${props => props.error && props.error === true ? '392px' : '666px'};
        padding: 49px 24px 46px;
        width: 81%;
        z-index: 1000;
        background: #FFFFFF;
        @media (min-width: 700px) {
            width: 610px;
            height: auto;
            max-height: ${props => props.error && props.error === true ? '425px' : '641px'};
        }
        @media (min-width: 1000px) {
            padding: 25px;
            width: 930px;
            border-radius: 5px;
        }
        @media (max-width: 700px) {
            top: ${props => !props.task ? props.error && props.error === true ? '260px' : '320px' : props.task === 'personal' ? '430px' : '442px'};
        }
        @media (max-width: 320px) {
            width: 79%;
        } 
    `,
    ModalTitle: styled.h3.attrs({ className: 'modal-title' })`
        font-family: Toyota Display Bold;
        font-size: 24px;
        line-height: 24px;
        letter-spacing: -1.32px;
        display: block;
        text-align: center;
        padding: 0;
        margin: 0;
        width: 90%;
        @media (min-width: 1000px) {
            font-size: 36px;
            line-height: 46px;
        }
    `,
    ModalTextContainer: styled.div.attrs({ className: 'modal-text-container' })`
        max-width: 839px;
        margin: 38px 17px 35px;
        min-height: 82px;
        max-height: 342px;
        overflow-y: auto;
        position: relative;
        &:after {
                position: fixed;
                display: ${props => props.content.length > 1 ? 'block' : 'none'};
                content: ' ';
                height: 40px;
                bottom: 127px;
                left: 0;
                width: 100%;
                background: ${props => props.error && props.error === true ? 'rgba(0, 0, 0, 0.0)' : 'linear-gradient(0deg,#FFFFFF 0%,rgba(255,255,255,0) 103.75%)'};
        }
    `,
    ModalText: styled.div.attrs({ className: 'modal-text' })`
        width: 100%;
        font-family: Toyota Display;
        font-size: 16px;
        line-height: 20px;
        color: #202020;
    `,
    ModalList: styled.ul.attrs({ className: 'modal-list' })` 
        text-align: left;
        list-style: none;
        margin: 0 5px 0 0;
        padding-left: 0;
        & li {
            margin-bottom: 10px;
        }
    `,
    ModalBody: styled.div.attrs({ className: 'modal-body' })`
        width: 100%;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: flex-start;
        @media (min-width: 1000px) {
            margin-top: 64px;
        }
    `,
    ModalClose: styled.div.attrs({ className: 'modal-close' })`
        width: auto;
        height: auto;
        position: absolute;
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;
        top: 11px;
        right: 9px;
        @media (min-width: 1000px) {
            top: 54px;
            right: 54px;
        }
    `,
    InputError: styled.span.attrs({ className: 'input-error' })`
        position: absolute;
        bottom: -20px;
        font-family: Toyota Display;
        font-style: normal;
        font-weight: normal;
        font-size: 12px;
        line-height: 16px;
        color: #E50000;
    `,
    ButtonNext: styled.div.attrs({ className: 'button-next' })`
        width: 152px;
        padding: 14px 0 16px;
        text-align: center;
        font-family: Toyota Display;
        font-style: normal;
        font-weight: bold;
        font-size: 15px;
        line-height: 20px;
        color: #E50000;
        background: #FFFFFF;
        border: 1px solid #E50000;
        box-sizing: border-box;
        border-radius: 25px;
        transition: opacity 0.2s ease-in-out;
        outline: none;
        -webkit-tap-highlight-color: transparent;
        cursor: pointer;
        &:active {
            background: #E50000;
            color: #FFFFFF;
        }
        &.opacity {
            opacity: 0.3;
        }
        @media(min-width: 700px) {
            margin-bottom: 15px;
        }
    `,
};
